/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Sessions_Tab_LogInputs */

const en_ui_sessions_tab_log = /** @type {(inputs: Ui_Sessions_Tab_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log`)
};

const de_ui_sessions_tab_log = /** @type {(inputs: Ui_Sessions_Tab_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protokoll`)
};

/**
* | output |
* | --- |
* | "Log" |
*
* @param {Ui_Sessions_Tab_LogInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_sessions_tab_log = /** @type {((inputs?: Ui_Sessions_Tab_LogInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Sessions_Tab_LogInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_sessions_tab_log(inputs)
	return de_ui_sessions_tab_log(inputs)
});